import React, { useState, useEffect } from 'react';

const EmailsTab = () => {
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = () => {
    const savedEmails = JSON.parse(localStorage.getItem('signup_emails') || '[]');
    setEmails(savedEmails);
  };

  const copyAllEmails = () => {
    navigator.clipboard.writeText(emails.join('\n'));
  };

  const exportCSV = () => {
    const csv = 'Email\n' + emails.join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'subscribers.csv';
    a.click();
  };

  const deleteEmail = (emailToDelete) => {
    const updated = emails.filter(e => e !== emailToDelete);
    setEmails(updated);
    localStorage.setItem('signup_emails', JSON.stringify(updated));
  };

  const clearAll = () => {
    if (window.confirm('Are you sure you want to delete all emails?')) {
      setEmails([]);
      localStorage.removeItem('signup_emails');
    }
  };

  return (
    <div>
      <div className="tab-section">
        <h3 className="section-title">Email Subscribers</h3>
        <p className="section-description">
          {emails.length} subscriber{emails.length !== 1 ? 's' : ''} registered
        </p>

        {emails.length > 0 && (
          <div className="email-actions" style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <button onClick={copyAllEmails} className="secondary-btn">
              Copy All
            </button>
            <button onClick={exportCSV} className="secondary-btn">
              Export CSV
            </button>
            <button onClick={clearAll} className="danger-btn" style={{ marginLeft: 'auto' }}>
              Clear All
            </button>
          </div>
        )}

        <div className="email-list" style={{ 
          maxHeight: '300px', 
          overflowY: 'auto',
          background: 'rgba(0,0,0,0.2)',
          borderRadius: '8px',
          padding: emails.length ? '8px' : '20px'
        }}>
          {emails.length === 0 ? (
            <p style={{ textAlign: 'center', opacity: 0.5, margin: 0 }}>
              No subscribers yet
            </p>
          ) : (
            emails.map((email, index) => (
              <div 
                key={index} 
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  borderBottom: index < emails.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none'
                }}
              >
                <span style={{ fontFamily: 'monospace', fontSize: '13px' }}>{email}</span>
                <button 
                  onClick={() => deleteEmail(email)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#888',
                    cursor: 'pointer',
                    padding: '4px 8px',
                    fontSize: '16px'
                  }}
                >
                  ×
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailsTab;

